const Section = ({ children, className = '', background = 'white' }) => {
  const bgClass = background === 'grey' ? 'bg-gray-50' : 'bg-white';
  
  return (
    <section className={`py-16 ${bgClass} ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {children}
      </div>
    </section>
  );
};

export default Section;